import {Link} from "react-router-dom";
import React, {useEffect, useState} from "react";

export const ProductsComponent = ({products , label, minilabel}) => {
    return(
        <div className={"mx-auto w-full md:w-11/12 lg:w-full "} style={{maxWidth:"1500px"}}>
            <div className={"w-full pt-14 md:pt-14"}>
                <div className={"w-full flex "}>
                    <div className={"w-full md:w-6/12 pb-12 md:pb-14 mx-auto"}>
                        <div className={"text-center block lg:flex items-center"}>
                            <div className={"lg:border-r lg:pe-6 md:ms-auto border-gray-700"}>
                                <h1 className={"text-main text-2xl lg:text-3xl font-semibold "}>
                                    {label}</h1>
                            </div>
                            <div className={"lg:ps-6 me-auto md:me-auto"}>
                                <h1 className={"text-red-600 font-semibold text-md"}>X R A Y</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"w-full"}>
                    <div className={"w-full max:w-11/12 mx-auto"}>
                        {products?.length === 0 ? (
                            <div className={""}>
                                <ul className={"w-full sm:w-11/12 mx-auto lg:w-full xl:w-11/12 md:w-11/12 flex flex-wrap "}>
                                    <li key={0} className={"w-6/12 md:w-6/12  lg:mx-0 lg:w-3/12"}>
                                        <div className={""}>
                                            <EmptyProductCardComponent index={0} />
                                        </div>
                                    </li>
                                    <li key={1} className={"w-6/12 md:w-6/12  lg:mx-0 lg:w-3/12"}>
                                        <div className={""}>
                                            <EmptyProductCardComponent index={0} />
                                        </div>
                                    </li>
                                    <li key={2} className={"w-6/12 md:w-6/12  lg:mx-0 lg:w-3/12"}>
                                        <div className={""}>
                                            <EmptyProductCardComponent index={0} />
                                        </div>
                                    </li>
                                    <li key={3} className={"w-6/12 md:w-6/12  lg:mx-0 lg:w-3/12"}>
                                        <div className={""}>
                                            <EmptyProductCardComponent index={0} />
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        ) : (
                            <ul className={"w-full sm:w-11/12 mx-auto lg:w-full xl:w-11/12 md:w-11/12 flex flex-wrap "}>
                                {products.map((item, index) => {
                                    return(
                                        <li key={index} className={"w-6/12 md:w-6/12  lg:mx-0 lg:w-3/12"}>
                                            <div className={""}>
                                                <ProductCardComponent index={index} name={item?.name} category={item?.category?.name} slug={item?.slug} model={item?.model?.name} type={item?.type} brochure={item?.brochure} image={item?.main_image}  />
                                            </div>
                                        </li>
                                    )
                                })}
                            </ul>
                        )}
                    </div>
                </div>
            </div>
            <div className={"w-full pt-5 border-t border-gray-200  my-6 md:my-0 md:py-4"}>
                <div className={"w-full md:w-11/12 lg:w-10/12 pt-6 pb-4 md:pb-0  mx-auto"}>
                    <ul className={"block lg:flex justify-between"}>
                        <li className={"gap-4 mb-4 md:my-4 w-full lg:w-4/12 "}>
                            <div className={"w-10/12 text-center mx-auto"}>
                                <div>
                                    <p className={"text-main font-medium text-lg"}>Teknologi Berkualitas</p>
                                    <p className={"text-sm font-light text-gray-500"}>
                                        Didukung dengan merek yang Berkualitas tinggi seperti Siemens,  Mettler Toledo, Oriental Motor, Habasit Belt Dan mereka Berkualitas lainnya untuk memastikan Unimax menjadi produk yang dihandalkan.
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li className={"gap-4 my-6 md:my-4 w-full lg:w-4/12"}>
                            <div className={"w-10/12 text-center mx-auto"}>
                                <div>
                                    <p className={"text-main font-medium text-lg"}>Harga Kompetitif</p>
                                    <p className={"text-sm font-light text-gray-500"}>
                                        Unimax memberikan Solusi yang sangat Berkualitas dengan dapat menekan nilai investasi.
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li className={"gap-4 mt-4 md:my-4 w-full lg:w-4/12"}>
                            <div className={"w-10/12 text-center mx-auto"}>
                                <div>
                                    <p className={"text-main font-medium text-lg"}>Garansi Mesin hingga 3 Tahun</p>
                                    <p className={"text-sm font-light text-gray-500"}>
                                        Kami menjamin Unimax adalah produk yang Berkualitas tinggi dengan memberikan komitmen garansi hingga 3 Tahun
                                    </p>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div className={"w-full py-8 border-t border-gray-200  my-6 md:py-4"}>
                <PartnerComponent />
            </div>
        </div>
    )
}


const PartnerComponent = () => {
    const partners = Array.from({ length: 7 }, (_, i) => i + 1); // Array [1, 2, 3, 4, 5, 6, 7]
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % partners.length);
        }, 2000);

        return () => clearInterval(interval);
    }, [partners.length]);


    return (
        <div className={"w-11/12 mb-6 mx-auto"}>
            <div className={"w-full pb-3 "}>
                <div className={"text-center my-5"}>
                    <h3 className={"font-semibold text-3xl text-gray-800"}>Komponen Partner</h3>
                </div>
            </div>
            <div className={"w-11/12 mx-auto"}>
                <div className="w-full my-8 md:hidden block  md:w-10/12 mx-auto">
                    <ul className="w-11/12 md:w-10/12 mx-auto items-center justify-center block md:flex flex-wrap">
                        {partners.map((partner, index) => (
                            <li
                                key={index}
                                className={`w-4/12 mx-auto md:mx-0 ${index === currentIndex ? 'opacity-100' : 'opacity-0 hidden'} transition-opacity duration-1000 ease-in-out`}
                            >
                                <div className="w-full rounded-lg transition-transform duration-500 ease-in-out hover:-translate-y-2 hover:scale-105">
                                    <div className="w-full h-24">
                                        <img
                                            className="w-full h-full object-contain"
                                            src={`/assets/partner/ptr-${partner}.png`}
                                            alt={`Partner ${partner}`}
                                        />
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
                <ul className={"w-full hidden md:flex gap-4"}>
                    {partners.map((partner) => (
                        <li key={partner} className={"mx-auto  cursor-pointer transition-transform duration-500 ease-in-out hover:-translate-y-2 hover:scale-105"}>
                            <div className={"h-9"}>
                                    <img
                                        className={"h-full object-contain"}
                                        src={`/assets/partner/ptr-${partner}.png`}
                                        alt={`Partner ${partner}`}
                                    />
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};




export const ProductCardComponent = ({ index, name, slug, image, type, category , model }) => {

    return (
        <>
            <div
                className={`w-full border   border-gray-200 group overflow-hidden ${index % 2 === 0 ? 'bg-gray-50': 'bg-white' } relative hover:shadow-xl hover:shadow-gray-400 transition-shadow duration-300`}
                tabIndex={0}>
                <div className="relative pt-6 pb-1 w-full">
                    <div className="absolute z-20 top-4 w-full">
                        <div className="w-11/12 mx-auto">
                            <div className="w-full flex ">
                                <div className=" my-auto hidden md:block text-center">
                                    <div className="relative bg-red-600 my-auto skew-x-12 py-1.5 md:py-2 px-2">
                                        <h2 className="text-white -skew-x-12 my-auto text-xs">{category}</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="pt-0 pb-5 md:pt-12 md:pb-12">
                        <div className="h-product-image">
                            <img
                                className="h-full object-contain w-11/12 mx-auto md:w-full transition-transform duration-300 ease-in-out group-hover:scale-110"
                                src={`${process.env.REACT_APP_PANEL_WEBSITE_ROUTE}${image}`}
                                alt={`Product image of ${name}`}
                            />
                        </div>
                    </div>
                    <div className="w-11/12 mx-auto">
                        <div className="transition-transform text-black  duration-300 mb-6 md:mb-10 cursor-pointer ease-in-out group-hover:-translate-y-5">
                            <h2 className="text-red-600 text-md  font-medium ">{model}</h2>
                            <div>
                                <div className="my-2 md:my-1">
                                    <h1 className="md:text-md text-lg line-clamp-2 font-semibold">{name}</h1>
                                    <div className="my-0.5">
                                        <h2 className="font-light text-sm  line-clamp-1 text-gray-500">{type}</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        className="absolute bottom-0 z-30 left-0 w-full transform translate-y-full group-hover:translate-y-0 transition-transform duration-500"
                    >
                        <div className="w-full bg-white py-3 md:py-7 shadow">
                            <div className="w-11/12 mx-auto">
                                <a
                                    href={`/product/${slug}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <div
                                        className="bg-red-600 text-sm text-white text-center font-medium py-3.5 w-full"
                                    >
                                        Lihat Detail
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export const ProductExternalCardComponent = ({ index, name, slug, image, type, category , model }) => {

    return (
        <>
            <div
                className={`w-full border   border-gray-200 group overflow-hidden ${index % 2 === 0 ? 'bg-gray-50': 'bg-white' } relative hover:shadow-xl hover:shadow-gray-400 transition-shadow duration-300`}
                tabIndex={0}>
                <div className="relative pt-6 pb-1 w-full">
                    <div className="absolute z-20 top-4 w-full">
                        <div className="w-11/12 mx-auto">
                            <div className="w-full flex ">
                                <div className=" my-auto hidden md:block text-center">
                                    <div className="relative bg-red-600 my-auto skew-x-12 py-1.5 md:py-2 px-2">
                                        <h2 className="text-white line-clamp-1   -skew-x-12 my-auto text-xs">{category}</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="pt-0 pb-5 md:pt-12 md:pb-12">
                        <div className="h-product-image">
                            <img
                                className="h-full object-contain w-11/12 mx-auto md:w-full transition-transform duration-300 ease-in-out group-hover:scale-110"
                                src={`${process.env.REACT_APP_PANEL_WEBSITE_ROUTE}${image}`}
                                alt={`Product image of ${name}`}
                            />
                        </div>
                    </div>
                    <div className="w-11/12 mx-auto">
                        <div className="transition-transform text-black  duration-300 mb-6 md:mb-10 cursor-pointer ease-in-out group-hover:-translate-y-5">
                            <h2 className="text-red-600 text-md line-clamp-1 font-medium ">{model}</h2>
                            <div>
                                <div className="my-2 md:my-1">
                                    <h1 className="md:text-md line-clamp-2 text-lg font-semibold">{name}</h1>
                                    <div className="my-0.5">
                                        <h2 className="font-light line-clamp-1  text-sm text-gray-500">{type}</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        className="absolute bottom-0 z-30 left-0 w-full transform translate-y-full group-hover:translate-y-0 transition-transform duration-500"
                    >
                        <div className="w-full bg-white py-3 md:py-7 shadow">
                            <div className="w-11/12 mx-auto">
                                {category === 'Converyor Checkweigher' ? (
                                    <Link to={`https://checkweigher.co.id/product/${slug}`}>
                                        <div
                                            className="bg-red-600 text-sm text-white text-center font-medium py-3.5 w-full"
                                        >
                                            Lihat Detail
                                        </div>
                                    </Link>
                                ):(category === 'Metaldetector') ? (
                                    <Link to={`https://metaldetector.co.id/product/${slug}`}>
                                        <div
                                            className="bg-red-600 text-sm text-white text-center font-medium py-3.5 w-full"
                                        >
                                            Lihat Detail
                                        </div>
                                    </Link>
                                ): (
                                    <Link to={`/product/${slug}`}>
                                        <div
                                            className="bg-red-600 text-sm text-white text-center font-medium py-3.5 w-full"
                                        >
                                            Lihat Detail
                                        </div>
                                    </Link>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};


export const  EmptyProductCardComponent = ({index}) => {
    return(
        <div
            className={`w-full border rounded-lg  border-gray-50 group overflow-hidden animate-pulse bg-gray-100 relative hover:shadow-xl hover:shadow-gray-400 transition-shadow duration-300`}
            tabIndex={0}>
            <div className="relative pt-6 pb-1 w-full">
                <div className="absolute z-20 top-4 w-full">
                    <div className="w-11/12 mx-auto">
                        <div className="w-full flex ">
                        </div>
                    </div>
                </div>
                <div className="pt-0 pb-5 md:pt-0 md:pb-0 w-11/12 rounded-xl mx-auto">
                    <div className="h-product-image md:pt-10 md:pb-10  bg-gray-200 animate-pulse">
                        <div className="relative w-full md:mt-10 md:mb-10  h-full animate-pulse  overflow-hidden ">
                            <div className="absolute w-full h-full  "></div>
                        </div>
                    </div>
                </div>
                <div className="w-11/12 mx-auto">
                    <div className="transition-transform text-black duration-300 mb-6 md:mb-10 cursor-pointer ease-in-out group-hover:-translate-y-5">
                        <p className="text-red-600 text-sm font-medium text-md bg-empty-text"></p>
                        <div>
                            <div className="my-2 ">
                                <h3 className="font-semibold  my-3 h-5 w-10/12 animate-pulse  bg-gray-200 rounded-lg"></h3>
                                <div className="my-0.5">
                                    <p className="font-light text-sm w-6/12  bg-empty-text h-3 animate-pulse  bg-gray-200 text-gray-500"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    className="absolute bottom-0 z-30 left-0 w-full transform translate-y-full group-hover:translate-y-0 transition-transform duration-500"
                >
                    <div className="w-full bg-gray-100 py-3 shadow">
                        <div className="w-11/12 mx-auto">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
